export default "__VITE_ASSET__aadfa301__"